<template>
    <div id="paginator" class="ui pagination menu">
        <div is="FirstPage" :current_page="current_page" :disabled="disabled"></div>
        <div is="PrevPage" :page="prev_page" :disabled="disabled" v-if="style.width > 500"></div>
        <div
            is="Page"
            v-for="n in nambers_range"
            :page="n"
            :current_page="current_page"
            :total_pages="total_pages"
            :disabled="disabled"
        ></div>
        <div is="NextPage" :page="next_page" :disabled="disabled" v-if="style.width > 500"></div>
        <div is="LastPage" :current_page="current_page" :total_pages="total_pages" :disabled="disabled"></div>
    </div>
</template>

<script>
import Page from './page.vue'
import NextPage from './next.vue'
import LastPage from './last.vue'
import PrevPage from './previous.vue'
import FirstPage from './first.vue'
export default {
    name: "ToolPagination",
    props: {
        current_page: Number,
        total_pages: Number,
        change_page_channel: {
            default: "",
            type: String
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        prev_page() {
            if (this.current_page < 2) {
                return null
            } else {
                return this.current_page-1
            }
        },
        next_page() {
            if (this.current_page >= this.total_pages) {
                return null
            } else {
                return this.current_page+1
            }
        },
        nambers_range() {
            if (this.total_pages < 6) {
                return this.total_pages
            } else {
                if (this.current_page < 4 ) {
                    return Array.from({length: 5}, (v, k) => k+1)
                }
                if (this.current_page+4 > this.total_pages) {
                    return Array.from({length: 7}, (v, k) => this.total_pages-6+k)
                }
                return Array.from({length: 7}, (v, k) => this.current_page-2+k)
            }
        }
    },
    mounted() {
    },
    methods: {
        change_page(page = 1) {
            if (this.change_page_channel) {
                this.$bus.$emit(this.change_page_channel, page)
            } else {
                let query = _.cloneDeep(this.$route.query)
                if (query.page) delete query.page

                this.$router.push({
                    name: this.$router.name,
                    query: {...{page:page}, ...query},
                })
            }
        },
    },
    components: {
        Page,
        NextPage,
        LastPage,
        PrevPage,
        FirstPage
    }
}
</script>

<style lang="scss">
    @media only screen and (max-width: 767px) {
        #paginator .item {
            min-width: auto;
            padding: .92857143em .72857143em !important;
        }
    }
    @media only screen and (max-width: 360px) {
        #paginator .item {
            min-width: auto;
            padding: .92857143em .62857143em !important;
        }
    }
</style>
